import { Button } from 'flowbite-react'
import { Button as ButtonData } from '@/payload-types'
import FlowiteIconComponent from '../flowbite-icon/flowbiteIcon'

interface IProps {
  buttonData?: ButtonData | null | string
  label?: string
  url?: string
  size?: string
  buttonCSS?: string
  buttonTextCSS?: string
}

export const ButtonComponent = ({ buttonData, label, url, size, buttonCSS, buttonTextCSS }: IProps) => {
  let currentLabel
  if (typeof buttonData === 'object') {
    currentLabel = label === 'undefined' || label === undefined ? buttonData?.label : label

    return (
      <Button
        href={`${url}`}
        className={`py-0 flex items-center border-0 !ring-0 bg-${buttonData?.backgroundColor} ${buttonCSS} reportButton`}
        size={size}
        target='_blank'
      >
        <div className={`flex items-center justify-center text-sm font-medium leading-[21px] ${buttonTextCSS}`}>{currentLabel}</div>
        {typeof buttonData?.iconType == 'string' && (
          <FlowiteIconComponent iconType={buttonData.iconType}/>
        )}
      </Button>
    )
  }
}

export default ButtonComponent
